import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const TrackingEventTypeSchema = z.enum([
  'session_heartbeat',
  'page_enter',
  'page_exit',
  'click',
]);

export const TrackingEventDtoSchema = z.object({
  type: TrackingEventTypeSchema,
  sessionId: z.string(),
  pageViewId: z.string().optional(),
  occurredAt: z.string(),
  path: z.string().optional(),
  scrollDepthPercent: z.number().optional(),
  activeSeconds: z.number().optional(),
  elementLabel: z.string().optional(),
});

export type TrackingEventDto = z.infer<typeof TrackingEventDtoSchema>;

const PostTrackingEventsResponseDtoSchema = z.object({
  accepted: z.number(),
  skipped: z.number(),
});

export type PostTrackingEventsRequestDto = {
  events: TrackingEventDto[];
};
export type PostTrackingEventsResponseDto = z.infer<
  typeof PostTrackingEventsResponseDtoSchema
>;

/**
 * Axios-based client for the ingestion endpoint, used where a normal
 * request/response cycle is fine. The real-time flush path in
 * `shared/lib/tracking/tracking-client.ts` posts to the same endpoint
 * directly via `fetch` with `keepalive: true` instead of this function,
 * since axios cannot express `keepalive` and beacons on unload need it.
 */
export const postTrackingEvents = (
  data: PostTrackingEventsRequestDto,
  config?: AxiosRequestConfig<PostTrackingEventsRequestDto>
) => {
  return api
    .post('/tracking/events', data, config)
    .then(responseContract(PostTrackingEventsResponseDtoSchema));
};
